import React from 'react';
import {
  required,
  TextInput,
  SimpleForm,
  Create,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  Toolbar,
  SaveButton,
  CardActions,
  ListButton
} from 'react-admin';
import withStyles from "@material-ui/core/styles/withStyles";
//import SelectTraining from '../trainings/SelectTraining'
import SelectTraining from './Trainings'
import {RichTextInput} from 'ra-input-rich-text';

const editStyles = {
  root: { alignItems: "flex-start" },

  inlineBlock: {
    display: "inline-flex",
    marginRight: "8px",
  },
};

const CreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="Save"
            submitOnEnter={true}
            redirect="list"
        />
    </Toolbar>
);

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CreateActions = ({ basePath }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);
const QuestionCreate = ({...props }) => (
    <Create
    title='Add Questions'
    actions={<CreateActions />}
    {...props}
    >
        <SimpleForm   toolbar={<CreateToolbar />} >
            <SelectTraining  props={props} />
            <TextInput source="exam_name" label="Exam Name" validate={required()} />

            <ArrayInput source="question" label="Question(s)">
            <SimpleFormIterator>
            <RichTextInput
                source='passage'
                label="Passage"
            />
            <TextInput
                source="quest"
                label="Question"
                formClassName={props.classes.inlineBlock}
                fullWidth
                validate={required()}
            />
            <ArrayInput source="Choices" label="Choice(s)">
                <SimpleFormIterator>
                <TextInput
                    source="answer"
                    label=""
                    fullWidth
                    formClassName={props.classes.inlineBlock}
                />
                <BooleanInput
                    source="isAnswere"
                    label="Is this an answer?"
                    formClassName={props.classes.inlineBlock}
                />
            </SimpleFormIterator>
            </ArrayInput>
            </SimpleFormIterator>
        </ArrayInput>

            <TextInput
            type="number"
            source="passing_percentage"
            label="Passing Percentage"
            validate={required()}
            />
            <TextInput source="comments" label="Comments" />

        </SimpleForm>
    </Create>
)

export default withStyles(editStyles)(QuestionCreate);